module.exports = __webpack_public_path__ + "static/img/f778738c-e4f8-4870-b634-56703b4acafe.d25a6cc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/f778738c-e4f8-4870-b634-56703b4acafe.gif
// module id = ks4p
// module chunks = 1